import React from "react";
import Button from "@amzn/meridian/button";
import { useNavigate } from "react-router-dom";

const FooterButton = ({ path, children }) => {
  const navigate = useNavigate();

  const onFooterButtonClick = (path) => {
    navigate(path);
  };

  return (
    <Button type="icon" onClick={() => onFooterButtonClick(path)}>
      {children}
    </Button>
  );
};

export default FooterButton;
